import React, { useState } from 'react'
import { ListMenu, ListMenuButton, Spacer, Text, View, useWindowResizeSensor } from 'oio-react'
import PropTypes from 'prop-types'
import AccountIcon from 'assets/icons/account'
import CloseIcon from 'assets/icons/close'
import AboutMe from './AboutMe'
import ChangePassword from './ChangePassword'
import DeleteAccount from './DeleteAccount'
import ProfileInformation from './ProfileInformation'

// We use constants instead of routes so that the account settings component
// can be used in contexts that are both route and non-route based
const ACCOUNT_SETTINGS_SUBVIEW_1 = 'profile information'
const ACCOUNT_SETTINGS_SUBVIEW_2 = 'about me'
const ACCOUNT_SETTINGS_SUBVIEW_3 = 'change password'
const ACCOUNT_SETTINGS_SUBVIEW_4 = 'my account'

const AccountSettings = ({ onCloseButtonClick }) => {
   const { currentBreakpoint } = useWindowResizeSensor()
   const defaultSubview = currentBreakpoint > 'b' && ACCOUNT_SETTINGS_SUBVIEW_1
   const [subview, setSubview] = useState(defaultSubview)

   return (
      <View
         position="relative"
         borderRadius="6px[b-f]"
         style={{ overflow: 'hidden' }}
         float="left"
         width="100%"
         height="100%">
         <View
            float="left"
            width="100%[a-b] 240px[c-f]"
            height="100%"
            borderBottom="1px solid #eee[a-b]"
            borderRight="1px solid #eee[c-f]">
            <View
               borderBottom="1px solid #eee"
               padding="18px[a-b] 36px 30px[c-f]">
               <View
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="36px"
                  height="36px"
                  borderRadius="50%"
                  backgroundColor="#000">
                  <AccountIcon
                     width="20px"
                     height="20px"
                     strokeWidth="2px"
                     color="#fff"
                  />
               </View>
               <Spacer size="2" />
               <Text
                  size="5"
                  color="#000"
                  weight="medium">
                  Profile & Account Settings
               </Text>
               <Spacer size="2" />
               <Text size="2" color="#777">
                  {'Edit your profile information and account settings'}
               </Text>
            </View>
            <ListMenu buttonPaddingHorizontal="30px">
               <ListMenuButton
                  onClick={() => setSubview(ACCOUNT_SETTINGS_SUBVIEW_1)}
                  name="Profile Information"
                  isActive={subview === ACCOUNT_SETTINGS_SUBVIEW_1}
               />
               <ListMenuButton
                  onClick={() => setSubview(ACCOUNT_SETTINGS_SUBVIEW_2)}
                  name="About Me"
                  isActive={subview === ACCOUNT_SETTINGS_SUBVIEW_2}
               />
               <ListMenuButton
                  onClick={() => setSubview(ACCOUNT_SETTINGS_SUBVIEW_3)}
                  name="Change Password"
                  isActive={subview === ACCOUNT_SETTINGS_SUBVIEW_3}
               />
               <ListMenuButton
                  onClick={() => setSubview(ACCOUNT_SETTINGS_SUBVIEW_4)}
                  name="Delete Account"
                  isActive={subview === ACCOUNT_SETTINGS_SUBVIEW_4}
               />
            </ListMenu>
         </View>
         <View
            display={subview ? 'block' : 'none'}
            position="absolute[a-b] relative[c-f]"
            top="0px"
            left="0px"
            float="left"
            width="100%[a-b] calc(100% - 240px)[c-f]"
            height="100%"
            backgroundColor="#fff"
            scroll="on[a-b]">
            <View
               float="left"
               width="100%"
               height="100%[a-b] calc(100% - 60px)[c-f]">
               {subview === ACCOUNT_SETTINGS_SUBVIEW_1 && (
                  <ProfileInformation onReturnButtonClick={() => setSubview(null)} />
               )}
               {subview === ACCOUNT_SETTINGS_SUBVIEW_2 && (
                  <AboutMe onReturnButtonClick={() => setSubview(null)} />
               )}
               {subview === ACCOUNT_SETTINGS_SUBVIEW_3 && (
                  <ChangePassword onReturnButtonClick={() => setSubview(null)} />
               )}
               {subview === ACCOUNT_SETTINGS_SUBVIEW_4 && (
                  <DeleteAccount onReturnButtonClick={() => setSubview(null)} />
               )}
            </View>
         </View>
         <View
            position="absolute"
            right="0px"
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            height="60px"
            padding="0px 18px"
            zIndex="2">
            <View
               display="flex"
               justifyContent="flex-end"
               alignItems="center"
               onClick={onCloseButtonClick}>
               <CloseIcon width="24px" height="24px" />
            </View>
         </View>
      </View>
   )
}

AccountSettings.propTypes = {
   onCloseButtonClick: PropTypes.func.isRequired
}

export default AccountSettings
